import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Carga una imagen servida por un endpoint protegido (proxy de Azure) y la
 * devuelve como ObjectURL listo para un <img src=...>.
 *
 * El navegador NO manda el Bearer de localStorage en las peticiones de <img>,
 * por eso el proxy respondía 401 en silencio. Aquí descargamos el blob con
 * axios (con el token) y creamos un ObjectURL local, revocándolo al desmontar.
 *
 * Uso:
 *   const src = useImagenBlob(imagenCursoUrl(curso.imagen));
 *   {src ? <img src={src} /> : <Placeholder />}
 *
 * @param {string|null} url  URL completa del proxy de imagen (o null si no hay)
 * @returns {string|null}    ObjectURL para el <img>, o null mientras carga/!url
 */
export default function useImagenBlob(url) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!url) { setSrc(null); return undefined; }

    let activo = true;
    let objectUrl = null;

    axios
      .get(url, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .then((res) => {
        if (!activo) return;
        objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
      })
      .catch(() => { if (activo) setSrc(null); });

    return () => {
      activo = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return src;
}
